/* Generated by scripts/genTimeZones.mjs from Intl (Node 25.8.2, ICU 78.3).
 * Do not edit: npm run build writes it again. Every IANA zone, grouped by its
 * standard UTC offset, labelled as Google Meet does:
 * "(GMT-05:00) Eastern Time - New York". */
import { CURRENT_NAMES, zoneOption, type TimeZoneOption } from './timeZoneLabel.ts';

export type { TimeZoneOption };
export interface TimeZoneGroup { offsetMinutes: number; label: string; zones: TimeZoneOption[] }

export const TIME_ZONE_GROUPS: TimeZoneGroup[] = [
  {
    "offsetMinutes": -660,
    "label": "GMT-11:00",
    "zones": [
      {
        "id": "Pacific/Midway",
        "label": "(GMT-11:00) American Samoa Standard Time - Midway",
        "offsetMinutes": -660
      },
      {
        "id": "Pacific/Pago_Pago",
        "label": "(GMT-11:00) American Samoa Standard Time - Pago Pago",
        "offsetMinutes": -660
      },
      {
        "id": "Pacific/Niue",
        "label": "(GMT-11:00) Niue Time - Niue",
        "offsetMinutes": -660
      }
    ]
  },
  {
    "offsetMinutes": -600,
    "label": "GMT-10:00",
    "zones": [
      {
        "id": "Pacific/Rarotonga",
        "label": "(GMT-10:00) Cook Islands Standard Time - Rarotonga",
        "offsetMinutes": -600
      },
      {
        "id": "Pacific/Honolulu",
        "label": "(GMT-10:00) Hawaii-Aleutian Standard Time - Honolulu",
        "offsetMinutes": -600
      },
      {
        "id": "America/Adak",
        "label": "(GMT-10:00) Hawaii-Aleutian Time - Adak",
        "offsetMinutes": -600
      },
      {
        "id": "Pacific/Tahiti",
        "label": "(GMT-10:00) Tahiti Time - Tahiti",
        "offsetMinutes": -600
      }
    ]
  },
  {
    "offsetMinutes": -570,
    "label": "GMT-09:30",
    "zones": [
      {
        "id": "Pacific/Marquesas",
        "label": "(GMT-09:30) Marquesas Time - Marquesas",
        "offsetMinutes": -570
      }
    ]
  },
  {
    "offsetMinutes": -540,
    "label": "GMT-09:00",
    "zones": [
      {
        "id": "America/Anchorage",
        "label": "(GMT-09:00) Alaska Time - Anchorage",
        "offsetMinutes": -540
      },
      {
        "id": "America/Juneau",
        "label": "(GMT-09:00) Alaska Time - Juneau",
        "offsetMinutes": -540
      },
      {
        "id": "America/Metlakatla",
        "label": "(GMT-09:00) Alaska Time - Metlakatla",
        "offsetMinutes": -540
      },
      {
        "id": "America/Nome",
        "label": "(GMT-09:00) Alaska Time - Nome",
        "offsetMinutes": -540
      },
      {
        "id": "America/Sitka",
        "label": "(GMT-09:00) Alaska Time - Sitka",
        "offsetMinutes": -540
      },
      {
        "id": "America/Yakutat",
        "label": "(GMT-09:00) Alaska Time - Yakutat",
        "offsetMinutes": -540
      },
      {
        "id": "Pacific/Gambier",
        "label": "(GMT-09:00) Gambier Time - Gambier",
        "offsetMinutes": -540
      }
    ]
  },
  {
    "offsetMinutes": -480,
    "label": "GMT-08:00",
    "zones": [
      {
        "id": "America/Los_Angeles",
        "label": "(GMT-08:00) Pacific Time - Los Angeles",
        "offsetMinutes": -480
      },
      {
        "id": "America/Tijuana",
        "label": "(GMT-08:00) Pacific Time - Tijuana",
        "offsetMinutes": -480
      },
      {
        "id": "America/Vancouver",
        "label": "(GMT-08:00) Pacific Time - Vancouver",
        "offsetMinutes": -480
      },
      {
        "id": "Pacific/Pitcairn",
        "label": "(GMT-08:00) Pitcairn Time - Pitcairn",
        "offsetMinutes": -480
      }
    ]
  },
  {
    "offsetMinutes": -420,
    "label": "GMT-07:00",
    "zones": [
      {
        "id": "America/Hermosillo",
        "label": "(GMT-07:00) Mexican Pacific Standard Time - Hermosillo",
        "offsetMinutes": -420
      },
      {
        "id": "America/Mazatlan",
        "label": "(GMT-07:00) Mexican Pacific Standard Time - Mazatlan",
        "offsetMinutes": -420
      },
      {
        "id": "America/Creston",
        "label": "(GMT-07:00) Mountain Standard Time - Creston",
        "offsetMinutes": -420
      },
      {
        "id": "America/Dawson_Creek",
        "label": "(GMT-07:00) Mountain Standard Time - Dawson Creek",
        "offsetMinutes": -420
      },
      {
        "id": "America/Fort_Nelson",
        "label": "(GMT-07:00) Mountain Standard Time - Fort Nelson",
        "offsetMinutes": -420
      },
      {
        "id": "America/Phoenix",
        "label": "(GMT-07:00) Mountain Standard Time - Phoenix",
        "offsetMinutes": -420
      },
      {
        "id": "America/Boise",
        "label": "(GMT-07:00) Mountain Time - Boise",
        "offsetMinutes": -420
      },
      {
        "id": "America/Cambridge_Bay",
        "label": "(GMT-07:00) Mountain Time - Cambridge Bay",
        "offsetMinutes": -420
      },
      {
        "id": "America/Ciudad_Juarez",
        "label": "(GMT-07:00) Mountain Time - Ciudad Juarez",
        "offsetMinutes": -420
      },
      {
        "id": "America/Denver",
        "label": "(GMT-07:00) Mountain Time - Denver",
        "offsetMinutes": -420
      },
      {
        "id": "America/Edmonton",
        "label": "(GMT-07:00) Mountain Time - Edmonton",
        "offsetMinutes": -420
      },
      {
        "id": "America/Inuvik",
        "label": "(GMT-07:00) Mountain Time - Inuvik",
        "offsetMinutes": -420
      },
      {
        "id": "America/Dawson",
        "label": "(GMT-07:00) Yukon Time - Dawson",
        "offsetMinutes": -420
      },
      {
        "id": "America/Whitehorse",
        "label": "(GMT-07:00) Yukon Time - Whitehorse",
        "offsetMinutes": -420
      }
    ]
  },
  {
    "offsetMinutes": -360,
    "label": "GMT-06:00",
    "zones": [
      {
        "id": "America/Bahia_Banderas",
        "label": "(GMT-06:00) Central Standard Time - Bahia Banderas",
        "offsetMinutes": -360
      },
      {
        "id": "America/Belize",
        "label": "(GMT-06:00) Central Standard Time - Belize",
        "offsetMinutes": -360
      },
      {
        "id": "America/Chihuahua",
        "label": "(GMT-06:00) Central Standard Time - Chihuahua",
        "offsetMinutes": -360
      },
      {
        "id": "America/Costa_Rica",
        "label": "(GMT-06:00) Central Standard Time - Costa Rica",
        "offsetMinutes": -360
      },
      {
        "id": "America/El_Salvador",
        "label": "(GMT-06:00) Central Standard Time - El Salvador",
        "offsetMinutes": -360
      },
      {
        "id": "America/Guatemala",
        "label": "(GMT-06:00) Central Standard Time - Guatemala",
        "offsetMinutes": -360
      },
      {
        "id": "America/Managua",
        "label": "(GMT-06:00) Central Standard Time - Managua",
        "offsetMinutes": -360
      },
      {
        "id": "America/Merida",
        "label": "(GMT-06:00) Central Standard Time - Merida",
        "offsetMinutes": -360
      },
      {
        "id": "America/Mexico_City",
        "label": "(GMT-06:00) Central Standard Time - Mexico City",
        "offsetMinutes": -360
      },
      {
        "id": "America/Monterrey",
        "label": "(GMT-06:00) Central Standard Time - Monterrey",
        "offsetMinutes": -360
      },
      {
        "id": "America/Regina",
        "label": "(GMT-06:00) Central Standard Time - Regina",
        "offsetMinutes": -360
      },
      {
        "id": "America/Swift_Current",
        "label": "(GMT-06:00) Central Standard Time - Swift Current",
        "offsetMinutes": -360
      },
      {
        "id": "America/Tegucigalpa",
        "label": "(GMT-06:00) Central Standard Time - Tegucigalpa",
        "offsetMinutes": -360
      },
      {
        "id": "America/North_Dakota/Beulah",
        "label": "(GMT-06:00) Central Time - Beulah",
        "offsetMinutes": -360
      },
      {
        "id": "America/North_Dakota/Center",
        "label": "(GMT-06:00) Central Time - Center",
        "offsetMinutes": -360
      },
      {
        "id": "America/Chicago",
        "label": "(GMT-06:00) Central Time - Chicago",
        "offsetMinutes": -360
      },
      {
        "id": "America/Indiana/Knox",
        "label": "(GMT-06:00) Central Time - Knox",
        "offsetMinutes": -360
      },
      {
        "id": "America/Matamoros",
        "label": "(GMT-06:00) Central Time - Matamoros",
        "offsetMinutes": -360
      },
      {
        "id": "America/Menominee",
        "label": "(GMT-06:00) Central Time - Menominee",
        "offsetMinutes": -360
      },
      {
        "id": "America/North_Dakota/New_Salem",
        "label": "(GMT-06:00) Central Time - New Salem",
        "offsetMinutes": -360
      },
      {
        "id": "America/Ojinaga",
        "label": "(GMT-06:00) Central Time - Ojinaga",
        "offsetMinutes": -360
      },
      {
        "id": "America/Rankin_Inlet",
        "label": "(GMT-06:00) Central Time - Rankin Inlet",
        "offsetMinutes": -360
      },
      {
        "id": "America/Resolute",
        "label": "(GMT-06:00) Central Time - Resolute",
        "offsetMinutes": -360
      },
      {
        "id": "America/Indiana/Tell_City",
        "label": "(GMT-06:00) Central Time - Tell City",
        "offsetMinutes": -360
      },
      {
        "id": "America/Winnipeg",
        "label": "(GMT-06:00) Central Time - Winnipeg",
        "offsetMinutes": -360
      },
      {
        "id": "Pacific/Easter",
        "label": "(GMT-06:00) Easter Island Time - Easter",
        "offsetMinutes": -360
      },
      {
        "id": "Pacific/Galapagos",
        "label": "(GMT-06:00) Galapagos Time - Galapagos",
        "offsetMinutes": -360
      }
    ]
  },
  {
    "offsetMinutes": -300,
    "label": "GMT-05:00",
    "zones": [
      {
        "id": "America/Eirunepe",
        "label": "(GMT-05:00) Acre Standard Time - Eirunepe",
        "offsetMinutes": -300
      },
      {
        "id": "America/Rio_Branco",
        "label": "(GMT-05:00) Acre Standard Time - Rio Branco",
        "offsetMinutes": -300
      },
      {
        "id": "America/Bogota",
        "label": "(GMT-05:00) Colombia Standard Time - Bogota",
        "offsetMinutes": -300
      },
      {
        "id": "America/Havana",
        "label": "(GMT-05:00) Cuba Time - Havana",
        "offsetMinutes": -300
      },
      {
        "id": "America/Coral_Harbour",
        "label": "(GMT-05:00) Eastern Standard Time - Atikokan",
        "offsetMinutes": -300
      },
      {
        "id": "America/Cancun",
        "label": "(GMT-05:00) Eastern Standard Time - Cancun",
        "offsetMinutes": -300
      },
      {
        "id": "America/Cayman",
        "label": "(GMT-05:00) Eastern Standard Time - Cayman",
        "offsetMinutes": -300
      },
      {
        "id": "America/Jamaica",
        "label": "(GMT-05:00) Eastern Standard Time - Jamaica",
        "offsetMinutes": -300
      },
      {
        "id": "America/Panama",
        "label": "(GMT-05:00) Eastern Standard Time - Panama",
        "offsetMinutes": -300
      },
      {
        "id": "America/Detroit",
        "label": "(GMT-05:00) Eastern Time - Detroit",
        "offsetMinutes": -300
      },
      {
        "id": "America/Grand_Turk",
        "label": "(GMT-05:00) Eastern Time - Grand Turk",
        "offsetMinutes": -300
      },
      {
        "id": "America/Indianapolis",
        "label": "(GMT-05:00) Eastern Time - Indianapolis",
        "offsetMinutes": -300
      },
      {
        "id": "America/Iqaluit",
        "label": "(GMT-05:00) Eastern Time - Iqaluit",
        "offsetMinutes": -300
      },
      {
        "id": "America/Louisville",
        "label": "(GMT-05:00) Eastern Time - Louisville",
        "offsetMinutes": -300
      },
      {
        "id": "America/Indiana/Marengo",
        "label": "(GMT-05:00) Eastern Time - Marengo",
        "offsetMinutes": -300
      },
      {
        "id": "America/Kentucky/Monticello",
        "label": "(GMT-05:00) Eastern Time - Monticello",
        "offsetMinutes": -300
      },
      {
        "id": "America/Nassau",
        "label": "(GMT-05:00) Eastern Time - Nassau",
        "offsetMinutes": -300
      },
      {
        "id": "America/New_York",
        "label": "(GMT-05:00) Eastern Time - New York",
        "offsetMinutes": -300
      },
      {
        "id": "America/Indiana/Petersburg",
        "label": "(GMT-05:00) Eastern Time - Petersburg",
        "offsetMinutes": -300
      },
      {
        "id": "America/Port-au-Prince",
        "label": "(GMT-05:00) Eastern Time - Port-au-Prince",
        "offsetMinutes": -300
      },
      {
        "id": "America/Toronto",
        "label": "(GMT-05:00) Eastern Time - Toronto",
        "offsetMinutes": -300
      },
      {
        "id": "America/Indiana/Vevay",
        "label": "(GMT-05:00) Eastern Time - Vevay",
        "offsetMinutes": -300
      },
      {
        "id": "America/Indiana/Vincennes",
        "label": "(GMT-05:00) Eastern Time - Vincennes",
        "offsetMinutes": -300
      },
      {
        "id": "America/Indiana/Winamac",
        "label": "(GMT-05:00) Eastern Time - Winamac",
        "offsetMinutes": -300
      },
      {
        "id": "America/Guayaquil",
        "label": "(GMT-05:00) Ecuador Time - Guayaquil",
        "offsetMinutes": -300
      },
      {
        "id": "America/Lima",
        "label": "(GMT-05:00) Peru Standard Time - Lima",
        "offsetMinutes": -300
      }
    ]
  },
  {
    "offsetMinutes": -240,
    "label": "GMT-04:00",
    "zones": [
      {
        "id": "America/Boa_Vista",
        "label": "(GMT-04:00) Amazon Standard Time - Boa Vista",
        "offsetMinutes": -240
      },
      {
        "id": "America/Campo_Grande",
        "label": "(GMT-04:00) Amazon Standard Time - Campo Grande",
        "offsetMinutes": -240
      },
      {
        "id": "America/Cuiaba",
        "label": "(GMT-04:00) Amazon Standard Time - Cuiaba",
        "offsetMinutes": -240
      },
      {
        "id": "America/Manaus",
        "label": "(GMT-04:00) Amazon Standard Time - Manaus",
        "offsetMinutes": -240
      },
      {
        "id": "America/Porto_Velho",
        "label": "(GMT-04:00) Amazon Standard Time - Porto Velho",
        "offsetMinutes": -240
      },
      {
        "id": "America/Anguilla",
        "label": "(GMT-04:00) Atlantic Standard Time - Anguilla",
        "offsetMinutes": -240
      },
      {
        "id": "America/Antigua",
        "label": "(GMT-04:00) Atlantic Standard Time - Antigua",
        "offsetMinutes": -240
      },
      {
        "id": "America/Aruba",
        "label": "(GMT-04:00) Atlantic Standard Time - Aruba",
        "offsetMinutes": -240
      },
      {
        "id": "America/Barbados",
        "label": "(GMT-04:00) Atlantic Standard Time - Barbados",
        "offsetMinutes": -240
      },
      {
        "id": "America/Blanc-Sablon",
        "label": "(GMT-04:00) Atlantic Standard Time - Blanc-Sablon",
        "offsetMinutes": -240
      },
      {
        "id": "America/Curacao",
        "label": "(GMT-04:00) Atlantic Standard Time - Curacao",
        "offsetMinutes": -240
      },
      {
        "id": "America/Dominica",
        "label": "(GMT-04:00) Atlantic Standard Time - Dominica",
        "offsetMinutes": -240
      },
      {
        "id": "America/Grenada",
        "label": "(GMT-04:00) Atlantic Standard Time - Grenada",
        "offsetMinutes": -240
      },
      {
        "id": "America/Guadeloupe",
        "label": "(GMT-04:00) Atlantic Standard Time - Guadeloupe",
        "offsetMinutes": -240
      },
      {
        "id": "America/Kralendijk",
        "label": "(GMT-04:00) Atlantic Standard Time - Kralendijk",
        "offsetMinutes": -240
      },
      {
        "id": "America/Lower_Princes",
        "label": "(GMT-04:00) Atlantic Standard Time - Lower Princes",
        "offsetMinutes": -240
      },
      {
        "id": "America/Marigot",
        "label": "(GMT-04:00) Atlantic Standard Time - Marigot",
        "offsetMinutes": -240
      },
      {
        "id": "America/Martinique",
        "label": "(GMT-04:00) Atlantic Standard Time - Martinique",
        "offsetMinutes": -240
      },
      {
        "id": "America/Montserrat",
        "label": "(GMT-04:00) Atlantic Standard Time - Montserrat",
        "offsetMinutes": -240
      },
      {
        "id": "America/Port_of_Spain",
        "label": "(GMT-04:00) Atlantic Standard Time - Port of Spain",
        "offsetMinutes": -240
      },
      {
        "id": "America/Puerto_Rico",
        "label": "(GMT-04:00) Atlantic Standard Time - Puerto Rico",
        "offsetMinutes": -240
      },
      {
        "id": "America/Santo_Domingo",
        "label": "(GMT-04:00) Atlantic Standard Time - Santo Domingo",
        "offsetMinutes": -240
      },
      {
        "id": "America/St_Barthelemy",
        "label": "(GMT-04:00) Atlantic Standard Time - St Barthelemy",
        "offsetMinutes": -240
      },
      {
        "id": "America/St_Kitts",
        "label": "(GMT-04:00) Atlantic Standard Time - St Kitts",
        "offsetMinutes": -240
      },
      {
        "id": "America/St_Lucia",
        "label": "(GMT-04:00) Atlantic Standard Time - St Lucia",
        "offsetMinutes": -240
      },
      {
        "id": "America/St_Thomas",
        "label": "(GMT-04:00) Atlantic Standard Time - St Thomas",
        "offsetMinutes": -240
      },
      {
        "id": "America/St_Vincent",
        "label": "(GMT-04:00) Atlantic Standard Time - St Vincent",
        "offsetMinutes": -240
      },
      {
        "id": "America/Tortola",
        "label": "(GMT-04:00) Atlantic Standard Time - Tortola",
        "offsetMinutes": -240
      },
      {
        "id": "Atlantic/Bermuda",
        "label": "(GMT-04:00) Atlantic Time - Bermuda",
        "offsetMinutes": -240
      },
      {
        "id": "America/Glace_Bay",
        "label": "(GMT-04:00) Atlantic Time - Glace Bay",
        "offsetMinutes": -240
      },
      {
        "id": "America/Goose_Bay",
        "label": "(GMT-04:00) Atlantic Time - Goose Bay",
        "offsetMinutes": -240
      },
      {
        "id": "America/Halifax",
        "label": "(GMT-04:00) Atlantic Time - Halifax",
        "offsetMinutes": -240
      },
      {
        "id": "America/Moncton",
        "label": "(GMT-04:00) Atlantic Time - Moncton",
        "offsetMinutes": -240
      },
      {
        "id": "America/Thule",
        "label": "(GMT-04:00) Atlantic Time - Thule",
        "offsetMinutes": -240
      },
      {
        "id": "America/La_Paz",
        "label": "(GMT-04:00) Bolivia Time - La Paz",
        "offsetMinutes": -240
      },
      {
        "id": "America/Santiago",
        "label": "(GMT-04:00) Chile Time - Santiago",
        "offsetMinutes": -240
      },
      {
        "id": "America/Guyana",
        "label": "(GMT-04:00) Guyana Time - Guyana",
        "offsetMinutes": -240
      },
      {
        "id": "America/Caracas",
        "label": "(GMT-04:00) Venezuela Time - Caracas",
        "offsetMinutes": -240
      }
    ]
  },
  {
    "offsetMinutes": -210,
    "label": "GMT-03:30",
    "zones": [
      {
        "id": "America/St_Johns",
        "label": "(GMT-03:30) Newfoundland Time - St Johns",
        "offsetMinutes": -210
      }
    ]
  },
  {
    "offsetMinutes": -180,
    "label": "GMT-03:00",
    "zones": [
      {
        "id": "America/Buenos_Aires",
        "label": "(GMT-03:00) Argentina Standard Time - Buenos Aires",
        "offsetMinutes": -180
      },
      {
        "id": "America/Catamarca",
        "label": "(GMT-03:00) Argentina Standard Time - Catamarca",
        "offsetMinutes": -180
      },
      {
        "id": "America/Cordoba",
        "label": "(GMT-03:00) Argentina Standard Time - Cordoba",
        "offsetMinutes": -180
      },
      {
        "id": "America/Jujuy",
        "label": "(GMT-03:00) Argentina Standard Time - Jujuy",
        "offsetMinutes": -180
      },
      {
        "id": "America/Argentina/La_Rioja",
        "label": "(GMT-03:00) Argentina Standard Time - La Rioja",
        "offsetMinutes": -180
      },
      {
        "id": "America/Mendoza",
        "label": "(GMT-03:00) Argentina Standard Time - Mendoza",
        "offsetMinutes": -180
      },
      {
        "id": "America/Argentina/Rio_Gallegos",
        "label": "(GMT-03:00) Argentina Standard Time - Rio Gallegos",
        "offsetMinutes": -180
      },
      {
        "id": "America/Argentina/Salta",
        "label": "(GMT-03:00) Argentina Standard Time - Salta",
        "offsetMinutes": -180
      },
      {
        "id": "America/Argentina/San_Juan",
        "label": "(GMT-03:00) Argentina Standard Time - San Juan",
        "offsetMinutes": -180
      },
      {
        "id": "America/Argentina/San_Luis",
        "label": "(GMT-03:00) Argentina Standard Time - San Luis",
        "offsetMinutes": -180
      },
      {
        "id": "America/Argentina/Tucuman",
        "label": "(GMT-03:00) Argentina Standard Time - Tucuman",
        "offsetMinutes": -180
      },
      {
        "id": "America/Argentina/Ushuaia",
        "label": "(GMT-03:00) Argentina Standard Time - Ushuaia",
        "offsetMinutes": -180
      },
      {
        "id": "America/Araguaina",
        "label": "(GMT-03:00) Brasilia Standard Time - Araguaina",
        "offsetMinutes": -180
      },
      {
        "id": "America/Bahia",
        "label": "(GMT-03:00) Brasilia Standard Time - Bahia",
        "offsetMinutes": -180
      },
      {
        "id": "America/Belem",
        "label": "(GMT-03:00) Brasilia Standard Time - Belem",
        "offsetMinutes": -180
      },
      {
        "id": "America/Fortaleza",
        "label": "(GMT-03:00) Brasilia Standard Time - Fortaleza",
        "offsetMinutes": -180
      },
      {
        "id": "America/Maceio",
        "label": "(GMT-03:00) Brasilia Standard Time - Maceio",
        "offsetMinutes": -180
      },
      {
        "id": "America/Recife",
        "label": "(GMT-03:00) Brasilia Standard Time - Recife",
        "offsetMinutes": -180
      },
      {
        "id": "America/Santarem",
        "label": "(GMT-03:00) Brasilia Standard Time - Santarem",
        "offsetMinutes": -180
      },
      {
        "id": "America/Sao_Paulo",
        "label": "(GMT-03:00) Brasilia Standard Time - Sao Paulo",
        "offsetMinutes": -180
      },
      {
        "id": "America/Coyhaique",
        "label": "(GMT-03:00) Coyhaique Time - Coyhaique",
        "offsetMinutes": -180
      },
      {
        "id": "Atlantic/Stanley",
        "label": "(GMT-03:00) Falkland Islands Standard Time - Stanley",
        "offsetMinutes": -180
      },
      {
        "id": "America/Cayenne",
        "label": "(GMT-03:00) French Guiana Time - Cayenne",
        "offsetMinutes": -180
      },
      {
        "id": "Antarctica/Palmer",
        "label": "(GMT-03:00) Palmer Land Time - Palmer",
        "offsetMinutes": -180
      },
      {
        "id": "America/Asuncion",
        "label": "(GMT-03:00) Paraguay Standard Time - Asuncion",
        "offsetMinutes": -180
      },
      {
        "id": "America/Punta_Arenas",
        "label": "(GMT-03:00) Punta Arenas Time - Punta Arenas",
        "offsetMinutes": -180
      },
      {
        "id": "Antarctica/Rothera",
        "label": "(GMT-03:00) Rothera Time - Rothera",
        "offsetMinutes": -180
      },
      {
        "id": "America/Miquelon",
        "label": "(GMT-03:00) St. Pierre & Miquelon Time - Miquelon",
        "offsetMinutes": -180
      },
      {
        "id": "America/Paramaribo",
        "label": "(GMT-03:00) Suriname Time - Paramaribo",
        "offsetMinutes": -180
      },
      {
        "id": "America/Montevideo",
        "label": "(GMT-03:00) Uruguay Standard Time - Montevideo",
        "offsetMinutes": -180
      }
    ]
  },
  {
    "offsetMinutes": -120,
    "label": "GMT-02:00",
    "zones": [
      {
        "id": "America/Noronha",
        "label": "(GMT-02:00) Fernando de Noronha Standard Time - Noronha",
        "offsetMinutes": -120
      },
      {
        "id": "America/Godthab",
        "label": "(GMT-02:00) Greenland Time - Nuuk",
        "offsetMinutes": -120
      },
      {
        "id": "America/Scoresbysund",
        "label": "(GMT-02:00) Greenland Time - Scoresbysund",
        "offsetMinutes": -120
      },
      {
        "id": "Atlantic/South_Georgia",
        "label": "(GMT-02:00) South Georgia Time - South Georgia",
        "offsetMinutes": -120
      }
    ]
  },
  {
    "offsetMinutes": -60,
    "label": "GMT-01:00",
    "zones": [
      {
        "id": "Atlantic/Azores",
        "label": "(GMT-01:00) Azores Time - Azores",
        "offsetMinutes": -60
      },
      {
        "id": "Atlantic/Cape_Verde",
        "label": "(GMT-01:00) Cape Verde Standard Time - Cape Verde",
        "offsetMinutes": -60
      }
    ]
  },
  {
    "offsetMinutes": 0,
    "label": "GMT+00:00",
    "zones": [
      {
        "id": "UTC",
        "label": "(GMT+00:00) Coordinated Universal Time",
        "offsetMinutes": 0
      },
      {
        "id": "Africa/Abidjan",
        "label": "(GMT+00:00) Greenwich Mean Time - Abidjan",
        "offsetMinutes": 0
      },
      {
        "id": "Africa/Accra",
        "label": "(GMT+00:00) Greenwich Mean Time - Accra",
        "offsetMinutes": 0
      },
      {
        "id": "Africa/Bamako",
        "label": "(GMT+00:00) Greenwich Mean Time - Bamako",
        "offsetMinutes": 0
      },
      {
        "id": "Africa/Banjul",
        "label": "(GMT+00:00) Greenwich Mean Time - Banjul",
        "offsetMinutes": 0
      },
      {
        "id": "Africa/Bissau",
        "label": "(GMT+00:00) Greenwich Mean Time - Bissau",
        "offsetMinutes": 0
      },
      {
        "id": "Africa/Conakry",
        "label": "(GMT+00:00) Greenwich Mean Time - Conakry",
        "offsetMinutes": 0
      },
      {
        "id": "Africa/Dakar",
        "label": "(GMT+00:00) Greenwich Mean Time - Dakar",
        "offsetMinutes": 0
      },
      {
        "id": "America/Danmarkshavn",
        "label": "(GMT+00:00) Greenwich Mean Time - Danmarkshavn",
        "offsetMinutes": 0
      },
      {
        "id": "Africa/Freetown",
        "label": "(GMT+00:00) Greenwich Mean Time - Freetown",
        "offsetMinutes": 0
      },
      {
        "id": "Africa/Lome",
        "label": "(GMT+00:00) Greenwich Mean Time - Lome",
        "offsetMinutes": 0
      },
      {
        "id": "Africa/Monrovia",
        "label": "(GMT+00:00) Greenwich Mean Time - Monrovia",
        "offsetMinutes": 0
      },
      {
        "id": "Africa/Nouakchott",
        "label": "(GMT+00:00) Greenwich Mean Time - Nouakchott",
        "offsetMinutes": 0
      },
      {
        "id": "Africa/Ouagadougou",
        "label": "(GMT+00:00) Greenwich Mean Time - Ouagadougou",
        "offsetMinutes": 0
      },
      {
        "id": "Atlantic/Reykjavik",
        "label": "(GMT+00:00) Greenwich Mean Time - Reykjavik",
        "offsetMinutes": 0
      },
      {
        "id": "Africa/Sao_Tome",
        "label": "(GMT+00:00) Greenwich Mean Time - Sao Tome",
        "offsetMinutes": 0
      },
      {
        "id": "Atlantic/St_Helena",
        "label": "(GMT+00:00) Greenwich Mean Time - St Helena",
        "offsetMinutes": 0
      },
      {
        "id": "Europe/Guernsey",
        "label": "(GMT+00:00) Guernsey Time - Guernsey",
        "offsetMinutes": 0
      },
      {
        "id": "Europe/Dublin",
        "label": "(GMT+00:00) Ireland Time - Dublin",
        "offsetMinutes": 0
      },
      {
        "id": "Europe/Isle_of_Man",
        "label": "(GMT+00:00) Isle of Man Time - Isle of Man",
        "offsetMinutes": 0
      },
      {
        "id": "Europe/Jersey",
        "label": "(GMT+00:00) Jersey Time - Jersey",
        "offsetMinutes": 0
      },
      {
        "id": "Antarctica/Troll",
        "label": "(GMT+00:00) Troll Station Time - Troll",
        "offsetMinutes": 0
      },
      {
        "id": "Europe/London",
        "label": "(GMT+00:00) United Kingdom Time - London",
        "offsetMinutes": 0
      },
      {
        "id": "Atlantic/Canary",
        "label": "(GMT+00:00) Western European Time - Canary",
        "offsetMinutes": 0
      },
      {
        "id": "Atlantic/Faeroe",
        "label": "(GMT+00:00) Western European Time - Faroe",
        "offsetMinutes": 0
      },
      {
        "id": "Europe/Lisbon",
        "label": "(GMT+00:00) Western European Time - Lisbon",
        "offsetMinutes": 0
      },
      {
        "id": "Atlantic/Madeira",
        "label": "(GMT+00:00) Western European Time - Madeira",
        "offsetMinutes": 0
      }
    ]
  },
  {
    "offsetMinutes": 60,
    "label": "GMT+01:00",
    "zones": [
      {
        "id": "Africa/Algiers",
        "label": "(GMT+01:00) Central European Standard Time - Algiers",
        "offsetMinutes": 60
      },
      {
        "id": "Africa/Tunis",
        "label": "(GMT+01:00) Central European Standard Time - Tunis",
        "offsetMinutes": 60
      },
      {
        "id": "Europe/Amsterdam",
        "label": "(GMT+01:00) Central European Time - Amsterdam",
        "offsetMinutes": 60
      },
      {
        "id": "Europe/Andorra",
        "label": "(GMT+01:00) Central European Time - Andorra",
        "offsetMinutes": 60
      },
      {
        "id": "Europe/Belgrade",
        "label": "(GMT+01:00) Central European Time - Belgrade",
        "offsetMinutes": 60
      },
      {
        "id": "Europe/Berlin",
        "label": "(GMT+01:00) Central European Time - Berlin",
        "offsetMinutes": 60
      },
      {
        "id": "Europe/Bratislava",
        "label": "(GMT+01:00) Central European Time - Bratislava",
        "offsetMinutes": 60
      },
      {
        "id": "Europe/Brussels",
        "label": "(GMT+01:00) Central European Time - Brussels",
        "offsetMinutes": 60
      },
      {
        "id": "Europe/Budapest",
        "label": "(GMT+01:00) Central European Time - Budapest",
        "offsetMinutes": 60
      },
      {
        "id": "Europe/Busingen",
        "label": "(GMT+01:00) Central European Time - Busingen",
        "offsetMinutes": 60
      },
      {
        "id": "Africa/Ceuta",
        "label": "(GMT+01:00) Central European Time - Ceuta",
        "offsetMinutes": 60
      },
      {
        "id": "Europe/Copenhagen",
        "label": "(GMT+01:00) Central European Time - Copenhagen",
        "offsetMinutes": 60
      },
      {
        "id": "Europe/Gibraltar",
        "label": "(GMT+01:00) Central European Time - Gibraltar",
        "offsetMinutes": 60
      },
      {
        "id": "Europe/Ljubljana",
        "label": "(GMT+01:00) Central European Time - Ljubljana",
        "offsetMinutes": 60
      },
      {
        "id": "Arctic/Longyearbyen",
        "label": "(GMT+01:00) Central European Time - Longyearbyen",
        "offsetMinutes": 60
      },
      {
        "id": "Europe/Luxembourg",
        "label": "(GMT+01:00) Central European Time - Luxembourg",
        "offsetMinutes": 60
      },
      {
        "id": "Europe/Madrid",
        "label": "(GMT+01:00) Central European Time - Madrid",
        "offsetMinutes": 60
      },
      {
        "id": "Europe/Malta",
        "label": "(GMT+01:00) Central European Time - Malta",
        "offsetMinutes": 60
      },
      {
        "id": "Europe/Monaco",
        "label": "(GMT+01:00) Central European Time - Monaco",
        "offsetMinutes": 60
      },
      {
        "id": "Europe/Oslo",
        "label": "(GMT+01:00) Central European Time - Oslo",
        "offsetMinutes": 60
      },
      {
        "id": "Europe/Paris",
        "label": "(GMT+01:00) Central European Time - Paris",
        "offsetMinutes": 60
      },
      {
        "id": "Europe/Podgorica",
        "label": "(GMT+01:00) Central European Time - Podgorica",
        "offsetMinutes": 60
      },
      {
        "id": "Europe/Prague",
        "label": "(GMT+01:00) Central European Time - Prague",
        "offsetMinutes": 60
      },
      {
        "id": "Europe/Rome",
        "label": "(GMT+01:00) Central European Time - Rome",
        "offsetMinutes": 60
      },
      {
        "id": "Europe/San_Marino",
        "label": "(GMT+01:00) Central European Time - San Marino",
        "offsetMinutes": 60
      },
      {
        "id": "Europe/Sarajevo",
        "label": "(GMT+01:00) Central European Time - Sarajevo",
        "offsetMinutes": 60
      },
      {
        "id": "Europe/Skopje",
        "label": "(GMT+01:00) Central European Time - Skopje",
        "offsetMinutes": 60
      },
      {
        "id": "Europe/Stockholm",
        "label": "(GMT+01:00) Central European Time - Stockholm",
        "offsetMinutes": 60
      },
      {
        "id": "Europe/Tirane",
        "label": "(GMT+01:00) Central European Time - Tirane",
        "offsetMinutes": 60
      },
      {
        "id": "Europe/Vaduz",
        "label": "(GMT+01:00) Central European Time - Vaduz",
        "offsetMinutes": 60
      },
      {
        "id": "Europe/Vatican",
        "label": "(GMT+01:00) Central European Time - Vatican",
        "offsetMinutes": 60
      },
      {
        "id": "Europe/Vienna",
        "label": "(GMT+01:00) Central European Time - Vienna",
        "offsetMinutes": 60
      },
      {
        "id": "Europe/Warsaw",
        "label": "(GMT+01:00) Central European Time - Warsaw",
        "offsetMinutes": 60
      },
      {
        "id": "Europe/Zagreb",
        "label": "(GMT+01:00) Central European Time - Zagreb",
        "offsetMinutes": 60
      },
      {
        "id": "Europe/Zurich",
        "label": "(GMT+01:00) Central European Time - Zurich",
        "offsetMinutes": 60
      },
      {
        "id": "Africa/Casablanca",
        "label": "(GMT+01:00) Morocco Time - Casablanca",
        "offsetMinutes": 60
      },
      {
        "id": "Africa/Bangui",
        "label": "(GMT+01:00) West Africa Time - Bangui",
        "offsetMinutes": 60
      },
      {
        "id": "Africa/Brazzaville",
        "label": "(GMT+01:00) West Africa Time - Brazzaville",
        "offsetMinutes": 60
      },
      {
        "id": "Africa/Douala",
        "label": "(GMT+01:00) West Africa Time - Douala",
        "offsetMinutes": 60
      },
      {
        "id": "Africa/Kinshasa",
        "label": "(GMT+01:00) West Africa Time - Kinshasa",
        "offsetMinutes": 60
      },
      {
        "id": "Africa/Lagos",
        "label": "(GMT+01:00) West Africa Time - Lagos",
        "offsetMinutes": 60
      },
      {
        "id": "Africa/Libreville",
        "label": "(GMT+01:00) West Africa Time - Libreville",
        "offsetMinutes": 60
      },
      {
        "id": "Africa/Luanda",
        "label": "(GMT+01:00) West Africa Time - Luanda",
        "offsetMinutes": 60
      },
      {
        "id": "Africa/Malabo",
        "label": "(GMT+01:00) West Africa Time - Malabo",
        "offsetMinutes": 60
      },
      {
        "id": "Africa/Ndjamena",
        "label": "(GMT+01:00) West Africa Time - Ndjamena",
        "offsetMinutes": 60
      },
      {
        "id": "Africa/Niamey",
        "label": "(GMT+01:00) West Africa Time - Niamey",
        "offsetMinutes": 60
      },
      {
        "id": "Africa/Porto-Novo",
        "label": "(GMT+01:00) West Africa Time - Porto-Novo",
        "offsetMinutes": 60
      },
      {
        "id": "Africa/El_Aaiun",
        "label": "(GMT+01:00) Western Sahara Time - El Aaiun",
        "offsetMinutes": 60
      }
    ]
  },
  {
    "offsetMinutes": 120,
    "label": "GMT+02:00",
    "zones": [
      {
        "id": "Africa/Blantyre",
        "label": "(GMT+02:00) Central Africa Time - Blantyre",
        "offsetMinutes": 120
      },
      {
        "id": "Africa/Bujumbura",
        "label": "(GMT+02:00) Central Africa Time - Bujumbura",
        "offsetMinutes": 120
      },
      {
        "id": "Africa/Gaborone",
        "label": "(GMT+02:00) Central Africa Time - Gaborone",
        "offsetMinutes": 120
      },
      {
        "id": "Africa/Harare",
        "label": "(GMT+02:00) Central Africa Time - Harare",
        "offsetMinutes": 120
      },
      {
        "id": "Africa/Juba",
        "label": "(GMT+02:00) Central Africa Time - Juba",
        "offsetMinutes": 120
      },
      {
        "id": "Africa/Khartoum",
        "label": "(GMT+02:00) Central Africa Time - Khartoum",
        "offsetMinutes": 120
      },
      {
        "id": "Africa/Kigali",
        "label": "(GMT+02:00) Central Africa Time - Kigali",
        "offsetMinutes": 120
      },
      {
        "id": "Africa/Lubumbashi",
        "label": "(GMT+02:00) Central Africa Time - Lubumbashi",
        "offsetMinutes": 120
      },
      {
        "id": "Africa/Lusaka",
        "label": "(GMT+02:00) Central Africa Time - Lusaka",
        "offsetMinutes": 120
      },
      {
        "id": "Africa/Maputo",
        "label": "(GMT+02:00) Central Africa Time - Maputo",
        "offsetMinutes": 120
      },
      {
        "id": "Africa/Windhoek",
        "label": "(GMT+02:00) Central Africa Time - Windhoek",
        "offsetMinutes": 120
      },
      {
        "id": "Europe/Kaliningrad",
        "label": "(GMT+02:00) Eastern European Standard Time - Kaliningrad",
        "offsetMinutes": 120
      },
      {
        "id": "Africa/Tripoli",
        "label": "(GMT+02:00) Eastern European Standard Time - Tripoli",
        "offsetMinutes": 120
      },
      {
        "id": "Europe/Athens",
        "label": "(GMT+02:00) Eastern European Time - Athens",
        "offsetMinutes": 120
      },
      {
        "id": "Asia/Beirut",
        "label": "(GMT+02:00) Eastern European Time - Beirut",
        "offsetMinutes": 120
      },
      {
        "id": "Europe/Bucharest",
        "label": "(GMT+02:00) Eastern European Time - Bucharest",
        "offsetMinutes": 120
      },
      {
        "id": "Africa/Cairo",
        "label": "(GMT+02:00) Eastern European Time - Cairo",
        "offsetMinutes": 120
      },
      {
        "id": "Europe/Chisinau",
        "label": "(GMT+02:00) Eastern European Time - Chisinau",
        "offsetMinutes": 120
      },
      {
        "id": "Asia/Famagusta",
        "label": "(GMT+02:00) Eastern European Time - Famagusta",
        "offsetMinutes": 120
      },
      {
        "id": "Asia/Gaza",
        "label": "(GMT+02:00) Eastern European Time - Gaza",
        "offsetMinutes": 120
      },
      {
        "id": "Asia/Hebron",
        "label": "(GMT+02:00) Eastern European Time - Hebron",
        "offsetMinutes": 120
      },
      {
        "id": "Europe/Helsinki",
        "label": "(GMT+02:00) Eastern European Time - Helsinki",
        "offsetMinutes": 120
      },
      {
        "id": "Europe/Kiev",
        "label": "(GMT+02:00) Eastern European Time - Kyiv",
        "offsetMinutes": 120
      },
      {
        "id": "Europe/Mariehamn",
        "label": "(GMT+02:00) Eastern European Time - Mariehamn",
        "offsetMinutes": 120
      },
      {
        "id": "Asia/Nicosia",
        "label": "(GMT+02:00) Eastern European Time - Nicosia",
        "offsetMinutes": 120
      },
      {
        "id": "Europe/Riga",
        "label": "(GMT+02:00) Eastern European Time - Riga",
        "offsetMinutes": 120
      },
      {
        "id": "Europe/Sofia",
        "label": "(GMT+02:00) Eastern European Time - Sofia",
        "offsetMinutes": 120
      },
      {
        "id": "Europe/Tallinn",
        "label": "(GMT+02:00) Eastern European Time - Tallinn",
        "offsetMinutes": 120
      },
      {
        "id": "Europe/Vilnius",
        "label": "(GMT+02:00) Eastern European Time - Vilnius",
        "offsetMinutes": 120
      },
      {
        "id": "Asia/Jerusalem",
        "label": "(GMT+02:00) Israel Time - Jerusalem",
        "offsetMinutes": 120
      },
      {
        "id": "Africa/Johannesburg",
        "label": "(GMT+02:00) South Africa Standard Time - Johannesburg",
        "offsetMinutes": 120
      },
      {
        "id": "Africa/Maseru",
        "label": "(GMT+02:00) South Africa Standard Time - Maseru",
        "offsetMinutes": 120
      },
      {
        "id": "Africa/Mbabane",
        "label": "(GMT+02:00) South Africa Standard Time - Mbabane",
        "offsetMinutes": 120
      }
    ]
  },
  {
    "offsetMinutes": 180,
    "label": "GMT+03:00",
    "zones": [
      {
        "id": "Asia/Aden",
        "label": "(GMT+03:00) Arabian Standard Time - Aden",
        "offsetMinutes": 180
      },
      {
        "id": "Asia/Baghdad",
        "label": "(GMT+03:00) Arabian Standard Time - Baghdad",
        "offsetMinutes": 180
      },
      {
        "id": "Asia/Bahrain",
        "label": "(GMT+03:00) Arabian Standard Time - Bahrain",
        "offsetMinutes": 180
      },
      {
        "id": "Asia/Kuwait",
        "label": "(GMT+03:00) Arabian Standard Time - Kuwait",
        "offsetMinutes": 180
      },
      {
        "id": "Asia/Qatar",
        "label": "(GMT+03:00) Arabian Standard Time - Qatar",
        "offsetMinutes": 180
      },
      {
        "id": "Asia/Riyadh",
        "label": "(GMT+03:00) Arabian Standard Time - Riyadh",
        "offsetMinutes": 180
      },
      {
        "id": "Africa/Addis_Ababa",
        "label": "(GMT+03:00) East Africa Time - Addis Ababa",
        "offsetMinutes": 180
      },
      {
        "id": "Indian/Antananarivo",
        "label": "(GMT+03:00) East Africa Time - Antananarivo",
        "offsetMinutes": 180
      },
      {
        "id": "Africa/Asmera",
        "label": "(GMT+03:00) East Africa Time - Asmara",
        "offsetMinutes": 180
      },
      {
        "id": "Indian/Comoro",
        "label": "(GMT+03:00) East Africa Time - Comoro",
        "offsetMinutes": 180
      },
      {
        "id": "Africa/Dar_es_Salaam",
        "label": "(GMT+03:00) East Africa Time - Dar es Salaam",
        "offsetMinutes": 180
      },
      {
        "id": "Africa/Djibouti",
        "label": "(GMT+03:00) East Africa Time - Djibouti",
        "offsetMinutes": 180
      },
      {
        "id": "Africa/Kampala",
        "label": "(GMT+03:00) East Africa Time - Kampala",
        "offsetMinutes": 180
      },
      {
        "id": "Indian/Mayotte",
        "label": "(GMT+03:00) East Africa Time - Mayotte",
        "offsetMinutes": 180
      },
      {
        "id": "Africa/Mogadishu",
        "label": "(GMT+03:00) East Africa Time - Mogadishu",
        "offsetMinutes": 180
      },
      {
        "id": "Africa/Nairobi",
        "label": "(GMT+03:00) East Africa Time - Nairobi",
        "offsetMinutes": 180
      },
      {
        "id": "Asia/Amman",
        "label": "(GMT+03:00) Jordan Time - Amman",
        "offsetMinutes": 180
      },
      {
        "id": "Europe/Kirov",
        "label": "(GMT+03:00) Moscow Standard Time - Kirov",
        "offsetMinutes": 180
      },
      {
        "id": "Europe/Minsk",
        "label": "(GMT+03:00) Moscow Standard Time - Minsk",
        "offsetMinutes": 180
      },
      {
        "id": "Europe/Moscow",
        "label": "(GMT+03:00) Moscow Standard Time - Moscow",
        "offsetMinutes": 180
      },
      {
        "id": "Europe/Simferopol",
        "label": "(GMT+03:00) Moscow Standard Time - Simferopol",
        "offsetMinutes": 180
      },
      {
        "id": "Europe/Volgograd",
        "label": "(GMT+03:00) Moscow Standard Time - Volgograd",
        "offsetMinutes": 180
      },
      {
        "id": "Antarctica/Syowa",
        "label": "(GMT+03:00) Syowa Time - Syowa",
        "offsetMinutes": 180
      },
      {
        "id": "Asia/Damascus",
        "label": "(GMT+03:00) Syria Time - Damascus",
        "offsetMinutes": 180
      },
      {
        "id": "Europe/Istanbul",
        "label": "(GMT+03:00) Türkiye Standard Time - Istanbul",
        "offsetMinutes": 180
      }
    ]
  },
  {
    "offsetMinutes": 210,
    "label": "GMT+03:30",
    "zones": [
      {
        "id": "Asia/Tehran",
        "label": "(GMT+03:30) Iran Standard Time - Tehran",
        "offsetMinutes": 210
      }
    ]
  },
  {
    "offsetMinutes": 240,
    "label": "GMT+04:00",
    "zones": [
      {
        "id": "Asia/Yerevan",
        "label": "(GMT+04:00) Armenia Standard Time - Yerevan",
        "offsetMinutes": 240
      },
      {
        "id": "Asia/Baku",
        "label": "(GMT+04:00) Azerbaijan Standard Time - Baku",
        "offsetMinutes": 240
      },
      {
        "id": "Asia/Tbilisi",
        "label": "(GMT+04:00) Georgia Standard Time - Tbilisi",
        "offsetMinutes": 240
      },
      {
        "id": "Asia/Dubai",
        "label": "(GMT+04:00) Gulf Standard Time - Dubai",
        "offsetMinutes": 240
      },
      {
        "id": "Asia/Muscat",
        "label": "(GMT+04:00) Gulf Standard Time - Muscat",
        "offsetMinutes": 240
      },
      {
        "id": "Indian/Mauritius",
        "label": "(GMT+04:00) Mauritius Standard Time - Mauritius",
        "offsetMinutes": 240
      },
      {
        "id": "Indian/Reunion",
        "label": "(GMT+04:00) Réunion Time - Reunion",
        "offsetMinutes": 240
      },
      {
        "id": "Europe/Astrakhan",
        "label": "(GMT+04:00) Samara Standard Time - Astrakhan",
        "offsetMinutes": 240
      },
      {
        "id": "Europe/Samara",
        "label": "(GMT+04:00) Samara Standard Time - Samara",
        "offsetMinutes": 240
      },
      {
        "id": "Europe/Saratov",
        "label": "(GMT+04:00) Samara Standard Time - Saratov",
        "offsetMinutes": 240
      },
      {
        "id": "Europe/Ulyanovsk",
        "label": "(GMT+04:00) Samara Standard Time - Ulyanovsk",
        "offsetMinutes": 240
      },
      {
        "id": "Indian/Mahe",
        "label": "(GMT+04:00) Seychelles Time - Mahe",
        "offsetMinutes": 240
      }
    ]
  },
  {
    "offsetMinutes": 270,
    "label": "GMT+04:30",
    "zones": [
      {
        "id": "Asia/Kabul",
        "label": "(GMT+04:30) Afghanistan Time - Kabul",
        "offsetMinutes": 270
      }
    ]
  },
  {
    "offsetMinutes": 300,
    "label": "GMT+05:00",
    "zones": [
      {
        "id": "Indian/Kerguelen",
        "label": "(GMT+05:00) French Southern & Antarctic Time - Kerguelen",
        "offsetMinutes": 300
      },
      {
        "id": "Asia/Almaty",
        "label": "(GMT+05:00) Kazakhstan Time - Almaty",
        "offsetMinutes": 300
      },
      {
        "id": "Asia/Aqtau",
        "label": "(GMT+05:00) Kazakhstan Time - Aqtau",
        "offsetMinutes": 300
      },
      {
        "id": "Asia/Aqtobe",
        "label": "(GMT+05:00) Kazakhstan Time - Aqtobe",
        "offsetMinutes": 300
      },
      {
        "id": "Asia/Atyrau",
        "label": "(GMT+05:00) Kazakhstan Time - Atyrau",
        "offsetMinutes": 300
      },
      {
        "id": "Asia/Oral",
        "label": "(GMT+05:00) Kazakhstan Time - Oral",
        "offsetMinutes": 300
      },
      {
        "id": "Asia/Qostanay",
        "label": "(GMT+05:00) Kazakhstan Time - Qostanay",
        "offsetMinutes": 300
      },
      {
        "id": "Asia/Qyzylorda",
        "label": "(GMT+05:00) Kazakhstan Time - Qyzylorda",
        "offsetMinutes": 300
      },
      {
        "id": "Indian/Maldives",
        "label": "(GMT+05:00) Maldives Time - Maldives",
        "offsetMinutes": 300
      },
      {
        "id": "Antarctica/Mawson",
        "label": "(GMT+05:00) Mawson Time - Mawson",
        "offsetMinutes": 300
      },
      {
        "id": "Asia/Karachi",
        "label": "(GMT+05:00) Pakistan Standard Time - Karachi",
        "offsetMinutes": 300
      },
      {
        "id": "Asia/Dushanbe",
        "label": "(GMT+05:00) Tajikistan Time - Dushanbe",
        "offsetMinutes": 300
      },
      {
        "id": "Asia/Ashgabat",
        "label": "(GMT+05:00) Turkmenistan Standard Time - Ashgabat",
        "offsetMinutes": 300
      },
      {
        "id": "Asia/Samarkand",
        "label": "(GMT+05:00) Uzbekistan Standard Time - Samarkand",
        "offsetMinutes": 300
      },
      {
        "id": "Asia/Tashkent",
        "label": "(GMT+05:00) Uzbekistan Standard Time - Tashkent",
        "offsetMinutes": 300
      },
      {
        "id": "Antarctica/Vostok",
        "label": "(GMT+05:00) Vostok Time - Vostok",
        "offsetMinutes": 300
      },
      {
        "id": "Asia/Yekaterinburg",
        "label": "(GMT+05:00) Yekaterinburg Standard Time - Yekaterinburg",
        "offsetMinutes": 300
      }
    ]
  },
  {
    "offsetMinutes": 330,
    "label": "GMT+05:30",
    "zones": [
      {
        "id": "Asia/Colombo",
        "label": "(GMT+05:30) India Standard Time - Colombo",
        "offsetMinutes": 330
      },
      {
        "id": "Asia/Calcutta",
        "label": "(GMT+05:30) India Standard Time - Kolkata",
        "offsetMinutes": 330
      }
    ]
  },
  {
    "offsetMinutes": 345,
    "label": "GMT+05:45",
    "zones": [
      {
        "id": "Asia/Katmandu",
        "label": "(GMT+05:45) Nepal Time - Kathmandu",
        "offsetMinutes": 345
      }
    ]
  },
  {
    "offsetMinutes": 360,
    "label": "GMT+06:00",
    "zones": [
      {
        "id": "Asia/Dhaka",
        "label": "(GMT+06:00) Bangladesh Standard Time - Dhaka",
        "offsetMinutes": 360
      },
      {
        "id": "Asia/Thimphu",
        "label": "(GMT+06:00) Bhutan Time - Thimphu",
        "offsetMinutes": 360
      },
      {
        "id": "Indian/Chagos",
        "label": "(GMT+06:00) Indian Ocean Time - Chagos",
        "offsetMinutes": 360
      },
      {
        "id": "Asia/Bishkek",
        "label": "(GMT+06:00) Kyrgyzstan Time - Bishkek",
        "offsetMinutes": 360
      },
      {
        "id": "Asia/Omsk",
        "label": "(GMT+06:00) Omsk Standard Time - Omsk",
        "offsetMinutes": 360
      },
      {
        "id": "Asia/Urumqi",
        "label": "(GMT+06:00) Ürümqi Time - Urumqi",
        "offsetMinutes": 360
      }
    ]
  },
  {
    "offsetMinutes": 390,
    "label": "GMT+06:30",
    "zones": [
      {
        "id": "Indian/Cocos",
        "label": "(GMT+06:30) Cocos Islands Time - Cocos",
        "offsetMinutes": 390
      },
      {
        "id": "Asia/Rangoon",
        "label": "(GMT+06:30) Myanmar Time - Yangon",
        "offsetMinutes": 390
      }
    ]
  },
  {
    "offsetMinutes": 420,
    "label": "GMT+07:00",
    "zones": [
      {
        "id": "Indian/Christmas",
        "label": "(GMT+07:00) Christmas Island Time - Christmas",
        "offsetMinutes": 420
      },
      {
        "id": "Antarctica/Davis",
        "label": "(GMT+07:00) Davis Time - Davis",
        "offsetMinutes": 420
      },
      {
        "id": "Asia/Bangkok",
        "label": "(GMT+07:00) Indochina Time - Bangkok",
        "offsetMinutes": 420
      },
      {
        "id": "Asia/Saigon",
        "label": "(GMT+07:00) Indochina Time - Ho Chi Minh",
        "offsetMinutes": 420
      },
      {
        "id": "Asia/Phnom_Penh",
        "label": "(GMT+07:00) Indochina Time - Phnom Penh",
        "offsetMinutes": 420
      },
      {
        "id": "Asia/Vientiane",
        "label": "(GMT+07:00) Indochina Time - Vientiane",
        "offsetMinutes": 420
      },
      {
        "id": "Asia/Hovd",
        "label": "(GMT+07:00) Khovd Standard Time - Hovd",
        "offsetMinutes": 420
      },
      {
        "id": "Asia/Barnaul",
        "label": "(GMT+07:00) Krasnoyarsk Standard Time - Barnaul",
        "offsetMinutes": 420
      },
      {
        "id": "Asia/Krasnoyarsk",
        "label": "(GMT+07:00) Krasnoyarsk Standard Time - Krasnoyarsk",
        "offsetMinutes": 420
      },
      {
        "id": "Asia/Novokuznetsk",
        "label": "(GMT+07:00) Krasnoyarsk Standard Time - Novokuznetsk",
        "offsetMinutes": 420
      },
      {
        "id": "Asia/Novosibirsk",
        "label": "(GMT+07:00) Krasnoyarsk Standard Time - Novosibirsk",
        "offsetMinutes": 420
      },
      {
        "id": "Asia/Tomsk",
        "label": "(GMT+07:00) Krasnoyarsk Standard Time - Tomsk",
        "offsetMinutes": 420
      },
      {
        "id": "Asia/Jakarta",
        "label": "(GMT+07:00) Western Indonesia Time - Jakarta",
        "offsetMinutes": 420
      },
      {
        "id": "Asia/Pontianak",
        "label": "(GMT+07:00) Western Indonesia Time - Pontianak",
        "offsetMinutes": 420
      }
    ]
  },
  {
    "offsetMinutes": 480,
    "label": "GMT+08:00",
    "zones": [
      {
        "id": "Antarctica/Casey",
        "label": "(GMT+08:00) Australian Western Standard Time - Casey",
        "offsetMinutes": 480
      },
      {
        "id": "Australia/Perth",
        "label": "(GMT+08:00) Australian Western Standard Time - Perth",
        "offsetMinutes": 480
      },
      {
        "id": "Asia/Brunei",
        "label": "(GMT+08:00) Brunei Time - Brunei",
        "offsetMinutes": 480
      },
      {
        "id": "Asia/Makassar",
        "label": "(GMT+08:00) Central Indonesia Time - Makassar",
        "offsetMinutes": 480
      },
      {
        "id": "Asia/Macau",
        "label": "(GMT+08:00) China Standard Time - Macau",
        "offsetMinutes": 480
      },
      {
        "id": "Asia/Shanghai",
        "label": "(GMT+08:00) China Standard Time - Shanghai",
        "offsetMinutes": 480
      },
      {
        "id": "Asia/Hong_Kong",
        "label": "(GMT+08:00) Hong Kong Standard Time - Hong Kong",
        "offsetMinutes": 480
      },
      {
        "id": "Asia/Irkutsk",
        "label": "(GMT+08:00) Irkutsk Standard Time - Irkutsk",
        "offsetMinutes": 480
      },
      {
        "id": "Asia/Kuala_Lumpur",
        "label": "(GMT+08:00) Malaysia Time - Kuala Lumpur",
        "offsetMinutes": 480
      },
      {
        "id": "Asia/Kuching",
        "label": "(GMT+08:00) Malaysia Time - Kuching",
        "offsetMinutes": 480
      },
      {
        "id": "Asia/Manila",
        "label": "(GMT+08:00) Philippine Standard Time - Manila",
        "offsetMinutes": 480
      },
      {
        "id": "Asia/Singapore",
        "label": "(GMT+08:00) Singapore Standard Time - Singapore",
        "offsetMinutes": 480
      },
      {
        "id": "Asia/Taipei",
        "label": "(GMT+08:00) Taiwan Standard Time - Taipei",
        "offsetMinutes": 480
      },
      {
        "id": "Asia/Ulaanbaatar",
        "label": "(GMT+08:00) Ulaanbaatar Standard Time - Ulaanbaatar",
        "offsetMinutes": 480
      }
    ]
  },
  {
    "offsetMinutes": 525,
    "label": "GMT+08:45",
    "zones": [
      {
        "id": "Australia/Eucla",
        "label": "(GMT+08:45) Australian Central Western Standard Time - Eucla",
        "offsetMinutes": 525
      }
    ]
  },
  {
    "offsetMinutes": 540,
    "label": "GMT+09:00",
    "zones": [
      {
        "id": "Asia/Jayapura",
        "label": "(GMT+09:00) Eastern Indonesia Time - Jayapura",
        "offsetMinutes": 540
      },
      {
        "id": "Asia/Tokyo",
        "label": "(GMT+09:00) Japan Standard Time - Tokyo",
        "offsetMinutes": 540
      },
      {
        "id": "Asia/Pyongyang",
        "label": "(GMT+09:00) Korean Standard Time - Pyongyang",
        "offsetMinutes": 540
      },
      {
        "id": "Asia/Seoul",
        "label": "(GMT+09:00) Korean Standard Time - Seoul",
        "offsetMinutes": 540
      },
      {
        "id": "Pacific/Palau",
        "label": "(GMT+09:00) Palau Time - Palau",
        "offsetMinutes": 540
      },
      {
        "id": "Asia/Dili",
        "label": "(GMT+09:00) Timor-Leste Time - Dili",
        "offsetMinutes": 540
      },
      {
        "id": "Asia/Chita",
        "label": "(GMT+09:00) Yakutsk Standard Time - Chita",
        "offsetMinutes": 540
      },
      {
        "id": "Asia/Khandyga",
        "label": "(GMT+09:00) Yakutsk Standard Time - Khandyga",
        "offsetMinutes": 540
      },
      {
        "id": "Asia/Yakutsk",
        "label": "(GMT+09:00) Yakutsk Standard Time - Yakutsk",
        "offsetMinutes": 540
      }
    ]
  },
  {
    "offsetMinutes": 570,
    "label": "GMT+09:30",
    "zones": [
      {
        "id": "Australia/Darwin",
        "label": "(GMT+09:30) Australian Central Standard Time - Darwin",
        "offsetMinutes": 570
      },
      {
        "id": "Australia/Adelaide",
        "label": "(GMT+09:30) Australian Central Time - Adelaide",
        "offsetMinutes": 570
      },
      {
        "id": "Australia/Broken_Hill",
        "label": "(GMT+09:30) Australian Central Time - Broken Hill",
        "offsetMinutes": 570
      }
    ]
  },
  {
    "offsetMinutes": 600,
    "label": "GMT+10:00",
    "zones": [
      {
        "id": "Australia/Brisbane",
        "label": "(GMT+10:00) Australian Eastern Standard Time - Brisbane",
        "offsetMinutes": 600
      },
      {
        "id": "Australia/Lindeman",
        "label": "(GMT+10:00) Australian Eastern Standard Time - Lindeman",
        "offsetMinutes": 600
      },
      {
        "id": "Australia/Hobart",
        "label": "(GMT+10:00) Australian Eastern Time - Hobart",
        "offsetMinutes": 600
      },
      {
        "id": "Antarctica/Macquarie",
        "label": "(GMT+10:00) Australian Eastern Time - Macquarie",
        "offsetMinutes": 600
      },
      {
        "id": "Australia/Melbourne",
        "label": "(GMT+10:00) Australian Eastern Time - Melbourne",
        "offsetMinutes": 600
      },
      {
        "id": "Australia/Sydney",
        "label": "(GMT+10:00) Australian Eastern Time - Sydney",
        "offsetMinutes": 600
      },
      {
        "id": "Pacific/Guam",
        "label": "(GMT+10:00) Chamorro Standard Time - Guam",
        "offsetMinutes": 600
      },
      {
        "id": "Pacific/Saipan",
        "label": "(GMT+10:00) Chamorro Standard Time - Saipan",
        "offsetMinutes": 600
      },
      {
        "id": "Pacific/Truk",
        "label": "(GMT+10:00) Chuuk Time - Chuuk",
        "offsetMinutes": 600
      },
      {
        "id": "Antarctica/DumontDUrville",
        "label": "(GMT+10:00) Dumont d’Urville Time - DumontDUrville",
        "offsetMinutes": 600
      },
      {
        "id": "Pacific/Port_Moresby",
        "label": "(GMT+10:00) Papua New Guinea Time - Port Moresby",
        "offsetMinutes": 600
      },
      {
        "id": "Asia/Ust-Nera",
        "label": "(GMT+10:00) Vladivostok Standard Time - Ust-Nera",
        "offsetMinutes": 600
      },
      {
        "id": "Asia/Vladivostok",
        "label": "(GMT+10:00) Vladivostok Standard Time - Vladivostok",
        "offsetMinutes": 600
      }
    ]
  },
  {
    "offsetMinutes": 630,
    "label": "GMT+10:30",
    "zones": [
      {
        "id": "Australia/Lord_Howe",
        "label": "(GMT+10:30) Lord Howe Time - Lord Howe",
        "offsetMinutes": 630
      }
    ]
  },
  {
    "offsetMinutes": 660,
    "label": "GMT+11:00",
    "zones": [
      {
        "id": "Pacific/Bougainville",
        "label": "(GMT+11:00) Bougainville Time - Bougainville",
        "offsetMinutes": 660
      },
      {
        "id": "Pacific/Kosrae",
        "label": "(GMT+11:00) Kosrae Time - Kosrae",
        "offsetMinutes": 660
      },
      {
        "id": "Asia/Magadan",
        "label": "(GMT+11:00) Magadan Standard Time - Magadan",
        "offsetMinutes": 660
      },
      {
        "id": "Asia/Sakhalin",
        "label": "(GMT+11:00) Magadan Standard Time - Sakhalin",
        "offsetMinutes": 660
      },
      {
        "id": "Asia/Srednekolymsk",
        "label": "(GMT+11:00) Magadan Standard Time - Srednekolymsk",
        "offsetMinutes": 660
      },
      {
        "id": "Pacific/Noumea",
        "label": "(GMT+11:00) New Caledonia Standard Time - Noumea",
        "offsetMinutes": 660
      },
      {
        "id": "Pacific/Norfolk",
        "label": "(GMT+11:00) Norfolk Island Time - Norfolk",
        "offsetMinutes": 660
      },
      {
        "id": "Pacific/Ponape",
        "label": "(GMT+11:00) Pohnpei Time - Pohnpei",
        "offsetMinutes": 660
      },
      {
        "id": "Pacific/Guadalcanal",
        "label": "(GMT+11:00) Solomon Islands Time - Guadalcanal",
        "offsetMinutes": 660
      },
      {
        "id": "Pacific/Efate",
        "label": "(GMT+11:00) Vanuatu Standard Time - Efate",
        "offsetMinutes": 660
      }
    ]
  },
  {
    "offsetMinutes": 720,
    "label": "GMT+12:00",
    "zones": [
      {
        "id": "Pacific/Fiji",
        "label": "(GMT+12:00) Fiji Standard Time - Fiji",
        "offsetMinutes": 720
      },
      {
        "id": "Pacific/Tarawa",
        "label": "(GMT+12:00) Gilbert Islands Time - Tarawa",
        "offsetMinutes": 720
      },
      {
        "id": "Asia/Anadyr",
        "label": "(GMT+12:00) Kamchatka Standard Time - Anadyr",
        "offsetMinutes": 720
      },
      {
        "id": "Asia/Kamchatka",
        "label": "(GMT+12:00) Kamchatka Standard Time - Kamchatka",
        "offsetMinutes": 720
      },
      {
        "id": "Pacific/Kwajalein",
        "label": "(GMT+12:00) Marshall Islands Time - Kwajalein",
        "offsetMinutes": 720
      },
      {
        "id": "Pacific/Majuro",
        "label": "(GMT+12:00) Marshall Islands Time - Majuro",
        "offsetMinutes": 720
      },
      {
        "id": "Pacific/Nauru",
        "label": "(GMT+12:00) Nauru Time - Nauru",
        "offsetMinutes": 720
      },
      {
        "id": "Pacific/Auckland",
        "label": "(GMT+12:00) New Zealand Time - Auckland",
        "offsetMinutes": 720
      },
      {
        "id": "Antarctica/McMurdo",
        "label": "(GMT+12:00) New Zealand Time - McMurdo",
        "offsetMinutes": 720
      },
      {
        "id": "Pacific/Funafuti",
        "label": "(GMT+12:00) Tuvalu Time - Funafuti",
        "offsetMinutes": 720
      },
      {
        "id": "Pacific/Wake",
        "label": "(GMT+12:00) Wake Island Time - Wake",
        "offsetMinutes": 720
      },
      {
        "id": "Pacific/Wallis",
        "label": "(GMT+12:00) Wallis & Futuna Time - Wallis",
        "offsetMinutes": 720
      }
    ]
  },
  {
    "offsetMinutes": 765,
    "label": "GMT+12:45",
    "zones": [
      {
        "id": "Pacific/Chatham",
        "label": "(GMT+12:45) Chatham Time - Chatham",
        "offsetMinutes": 765
      }
    ]
  },
  {
    "offsetMinutes": 780,
    "label": "GMT+13:00",
    "zones": [
      {
        "id": "Pacific/Enderbury",
        "label": "(GMT+13:00) Phoenix Islands Time - Kanton",
        "offsetMinutes": 780
      },
      {
        "id": "Pacific/Apia",
        "label": "(GMT+13:00) Samoa Standard Time - Apia",
        "offsetMinutes": 780
      },
      {
        "id": "Pacific/Fakaofo",
        "label": "(GMT+13:00) Tokelau Time - Fakaofo",
        "offsetMinutes": 780
      },
      {
        "id": "Pacific/Tongatapu",
        "label": "(GMT+13:00) Tonga Standard Time - Tongatapu",
        "offsetMinutes": 780
      }
    ]
  },
  {
    "offsetMinutes": 840,
    "label": "GMT+14:00",
    "zones": [
      {
        "id": "Pacific/Kiritimati",
        "label": "(GMT+14:00) Line Islands Time - Kiritimati",
        "offsetMinutes": 840
      }
    ]
  }
];

const BY_ID = new Map(TIME_ZONE_GROUPS.flatMap((g) => g.zones).map((z) => [z.id, z]));
// A device may report the current name of a zone Intl lists by an older one.
for (const [older, current] of Object.entries(CURRENT_NAMES)) {
  const z = BY_ID.get(older);
  if (z && !BY_ID.has(current)) BY_ID.set(current, z);
}

/** A zone's label: from the list, or from Intl for one it does not have. */
export function timeZoneLabel(id: string): string {
  return (BY_ID.get(id) ?? zoneOption(id)).label;
}

/** The device's zone, America/New_York when the device gives none. */
export function deviceTimeZone(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone || 'America/New_York';
}

/** Every zone, the device's first, then the rest by offset. */
export function timeZonesDeviceFirst(device: string = deviceTimeZone()): TimeZoneOption[] {
  const first = BY_ID.get(device) ?? zoneOption(device);
  return [first, ...TIME_ZONE_GROUPS.flatMap((g) => g.zones).filter((z) => z.id !== first.id)];
}
